import { isCNPJ, isCPF } from 'validation-br';
import * as z from 'zod';
import { getKeyFromSelector } from '../i18n';

export function onlyDigits<T extends z.ZodString>(schema: T) {
  return schema.transform(value => value.replace(/\D/g, ''));
}

export function optionalField<T extends z.ZodType>(schema: T) {
  return z.preprocess(v => (v === '' ? undefined : v), schema.optional());
}

export const cpfSchema = z
  .string()
  .trim()
  .min(1)
  .refine(isCPF, { error: getKeyFromSelector($ => $.validation.invalidCPF) });

export const cnpjSchema = z
  .string()
  .trim()
  .min(1)
  .refine(isCNPJ, { error: getKeyFromSelector($ => $.validation.invalidCNPJ) });

export const anyDocumentSchema = z
  .string()
  .trim()
  .min(1)
  .refine(value => isCPF(value) || isCNPJ(value), {
    error: getKeyFromSelector($ => $.validation.invalidDocument),
  });

function phoneSchema(error: string) {
  return z
    .string()
    .trim()
    .min(1)
    .apply(onlyDigits)
    .refine(val => val.length === 10 || val.length === 11, { error });
}

export const phoneNumberSchema = phoneSchema(
  getKeyFromSelector($ => $.validation.invalidPhoneNumber),
);

export const cellPhoneSchema = phoneSchema(
  getKeyFromSelector($ => $.validation.invalidCellNumber),
);

export const whatsAppSchema = phoneSchema(
  getKeyFromSelector($ => $.validation.invalidWhatsAppNumber),
);

const CEP_DIGIT_COUNT = 8;

export const cepSchema = z
  .string()
  .trim()
  .min(1)
  .refine(val => val.replace(/\D/g, '').length === CEP_DIGIT_COUNT, {
    error: getKeyFromSelector($ => $.validation.invalidCEP),
  });
